import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import {
  useAuthStore,
  useRefreshToken
} from '../../../zustand/authentication/use-auth-store'
import { authorization } from '../../../containers/authentication/constants'
import { authMutationKeys } from '../constants'

export const useLoginRefreshMutation = () => {
  const { setShowLoginPopup, setToken } = useAuthStore()
  const refreshToken = useRefreshToken()

  const handleLoginRefresh = async () => {
    const config = {
      method: 'post',
      headers: {
        Authorization: authorization
      },
      url: '/api/oauth/token',
      data: {
        refresh_token: refreshToken,
        grant_type: 'refresh_token'
      }
    }

    const { data } = await api('/api/oauth/token', config)
    return data
  }

  const handleMutation = async () => {
    try {
      const data = await handleLoginRefresh()
      if (data) {
        setToken(data)
      }
    } catch (error) {
      setShowLoginPopup(true)
      throw error
    }
  }

  return useMutation({
    mutationFn: handleMutation,
    mutationKey: authMutationKeys.REFRESH
  })
}
